import React, { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'
import { Row, Col } from 'reactstrap'
import config from '../../../../../config'
import TableBuilder from '../../../../../shared/components/table/TableBuilder'

const MONTH_NAMES = [
  'January', 'February', 'March', 'April', 'May', 'June',
  'July', 'August', 'September', 'October', 'November', 'December',
]

function getNextMonth() {
  const now = new Date()
  return ((now.getMonth() + 1) % 12) + 1 // getMonth() is 0-based; next month, wrapping Dec->Jan
}

export default function BudgetMonthlyPreviewPage() {
  const user = useSelector(store => store.authentication.user)
  const sellerSelect = useSelector(store => store.sellerSelect)

  const [selectedMonth, setSelectedMonth] = useState(getNextMonth)
  const [rowData, setRowData] = useState([])
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true)
      try {
        const headerWithAuth = {
          ...config.jsonHeader,
          authorization: `JWT ${user.jwtToken}`,
        }

        let url = `${config.serverUrl}/management/budget/monthly-preview?month=${selectedMonth}`
        if (sellerSelect.value > 1) {
          url += `&accountId=${sellerSelect.value}`
        }

        const response = await fetch(url, {
          method: 'GET',
          headers: headerWithAuth,
        })
        const data = await response.json()

        if (Array.isArray(data)) {
          setRowData(data)
        } else {
          setRowData([])
        }
      } catch (error) {
        console.error('Error fetching budget monthly preview:', error)
        setRowData([])
      } finally {
        setLoading(false)
      }
    }

    fetchData()
  }, [selectedMonth, sellerSelect.value, user.jwtToken])

  const columnDefs = [
    { field: 'account_id', headerName: 'Account ID', width: 120 },
    { field: 'ad_platform', headerName: 'Platform', width: 120 },
    { field: 'budget_group_name', headerName: 'Budget Group', flex: 1 },
    { field: 'budget_driver', headerName: 'Driver', width: 110 },
    {
      field: 'limitless_budget',
      headerName: 'Limitless Budget',
      width: 150,
      valueFormatter: (params) => (params.value !== null && params.value !== undefined ? params.value : ''),
    },
    { field: 'month_name', headerName: 'Month', width: 110 },
    { field: 'budget_year', headerName: 'Year', width: 90 },
    { field: 'days_in_month', headerName: 'Days in Month', width: 130 },
    {
      field: 'month_budget',
      headerName: 'Monthly Budget',
      width: 150,
      valueFormatter: (params) => {
        if (params.value === null || params.value === undefined) return ''
        return `$${Number(params.value).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
      },
    },
  ]

  const defaultColDef = {
    sortable: true,
    filter: true,
    resizable: true,
  }

  const monthSelector = (
    // eslint-disable-next-line jsx-a11y/label-has-associated-control
    <label style={{ marginBottom: 0, whiteSpace: 'nowrap', fontWeight: 600 }}>
      Month:
      <select
        className="form-control"
        value={selectedMonth}
        onChange={(e) => setSelectedMonth(Number(e.target.value))}
        style={{ marginLeft: '8px', display: 'inline-block', width: 'auto' }}
      >
        {MONTH_NAMES.map((name, index) => (
          <option key={name} value={index + 1}>
            {name}
          </option>
        ))}
      </select>
    </label>
  )

  return (
    <Row>
      <Col md={12}>
        {!loading && (
          <TableBuilder
            columnDefs={columnDefs}
            defaultColDef={defaultColDef}
            rowData={rowData}
            parentControlledLoad
            showDatePicker={false}
            toolbarLeftContent={monthSelector}
          />
        )}
      </Col>
    </Row>
  )
}
